import { VideoComponentContent } from '../../../types/elearning';

interface VideoBlockViewerProps {
  content: VideoComponentContent;
}

export default function VideoBlockViewer({ content }: VideoBlockViewerProps) {
  // Extract YouTube video ID from URL if full URL is provided
  const getYouTubeId = (urlOrId: string): string => {
    // If it's already just an ID, return it
    if (!urlOrId.includes('youtube.com') && !urlOrId.includes('youtu.be')) {
      return urlOrId;
    }

    // Extract ID from YouTube URL
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = urlOrId.match(regex);
    return match ? match[1] : urlOrId;
  };

  const videoId = getYouTubeId(content.youtubeId);
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="mb-6">
      <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
        <iframe
          src={embedUrl}
          className="absolute top-0 left-0 w-full h-full rounded-lg"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={content.caption || 'Video content'}
        />
      </div>
      {content.caption && (
        <p className="text-sm text-gray-600 text-center mt-2">{content.caption}</p>
      )}
    </div>
  );
}

